/** Tanzania mobile 07xxxxxxxx → E.164 digits for tel: / wa.me */
export function tzPhoneToE164Digits(displayOrDigits) {
  const d = String(displayOrDigits).replace(/\D/g, '');
  if (d.startsWith('255') && d.length >= 12) return d;
  if (d.startsWith('0') && d.length === 10) return `255${d.slice(1)}`;
  return d || '';
}

function parseEmailList(raw) {
  return String(raw || '')
    .split(/[,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function readSupportConfig() {
  const phoneDisplay = (process.env.REACT_APP_SUPPORT_PHONE || '0711416873').trim();
  const emailRaw = (
    process.env.REACT_APP_SUPPORT_EMAIL ||
    'info@fushholdings.co.tz, charlesmakoye70@gmail.com'
  ).trim();
  const emails = parseEmailList(emailRaw);

  const whatsappEnv = (process.env.REACT_APP_SUPPORT_WHATSAPP || '').trim();
  const waDigits = (whatsappEnv || tzPhoneToE164Digits(phoneDisplay)).replace(/\D/g, '');

  const waMessage = (
    process.env.REACT_APP_SUPPORT_WHATSAPP_TEXT ||
    'Habari, ninahitaji msaada kuhusu cbonline app.'
  ).trim();

  const hours = (process.env.REACT_APP_SUPPORT_HOURS || '').trim();
  return { phoneDisplay, emails, waDigits, waMessage, hours };
}

export function telHref(phoneDisplay) {
  const e164 = tzPhoneToE164Digits(phoneDisplay);
  return e164 ? `tel:+${e164}` : '';
}

export function buildWhatsAppHref(digits, message) {
  if (!digits) return '';
  const base = `https://wa.me/${digits}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}
